import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
// import reportWebVitals from "./reportWebVitals";
// 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
// https://kinderland-apis.herokuapp.com
// http://3.13.138.90:3004
// https://venettini.app
// react-scripts --openssl-legacy-provider start
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL;

const generateClassName = createGenerateClassName({
  productionPrefix: "app-jss",
  seed: "app",
});

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider generateClassName={generateClassName}>
      <App />
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
